/**
 * Authentication Types
 * SCR-801 (Registration), SCR-802 (Terms), SCR-803 (Forgot Password), SCR-804 (Change Password)
 */

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  passwordConfirm?: string;
  acceptTerms: boolean;
  acceptPrivacy: boolean;
  marketingConsent?: boolean;
}

export interface RegisterResponse {
  userId: string;
  email: string;
  requiresVerification: boolean;
  message: string;
}

export interface VerifyEmailRequest {
  verificationCode: string;
}

export interface VerifyEmailResponse {
  success: boolean;
  message: string;
  redirectUrl?: string;
}

export interface ResendVerificationRequest {
  email: string;
}

export interface ResendVerificationResponse {
  success: boolean;
  message: string;
  cooldownSeconds?: number;
}

export interface CheckEmailResponse {
  exists: boolean;
}

export type OAuthProviderName = 'google' | 'digid';

export interface OAuthProvider {
  name: OAuthProviderName;
  label: string;
  icon: string;
}

export interface TermsAcceptanceRequest {
  termsAccepted?: boolean;
  privacyAccepted?: boolean;
  ageConfirmed?: boolean;
  termsVersion: string;
  privacyVersion: string;
  acceptedAt?: string;
}

export interface TermsAcceptanceResponse {
  success: boolean;
  redirectUrl: string;
}

export interface LegalDocument {
  type: 'terms' | 'privacy' | 'cookies';
  version: string;
  content: string;
  effectiveDate: string;
  lastModified: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
  confirmPassword: string;
  logoutOtherSessions: boolean;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  logoutOtherSessions: boolean;
}

export interface PasswordChangeHistory {
  id: string;
  changedAt: string;
  ipAddress: string;
  device?: string;
  location?: string;
}

export interface VerifyResetTokenResponse {
  valid: boolean;
  email?: string;
}

export interface PasswordStrengthResult {
  score: number;
  requirements: PasswordRequirement[];
  feedback: string[];
}

export interface PasswordRequirement {
  id: string;
  label: string;
  met: boolean;
}

export const PASSWORD_REQUIREMENTS: Omit<PasswordRequirement, 'met'>[] = [
  { id: 'length', label: 'Minimaal 12 tekens' },
  { id: 'uppercase', label: 'Eén hoofdletter' },
  { id: 'lowercase', label: 'Eén kleine letter' },
  { id: 'number', label: 'Eén cijfer' },
  { id: 'special', label: 'Eén speciaal teken (!@#$%^&*)' },
];
